import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory, Redirect, Route } from "react-router-dom";
import localStorageContent from "../../services/localStorage";
import * as authActionCreators from "../../store/Actions/Authentication-creator";

const ProtectedRoutes = (props: any) => {
  const history = useHistory();
  const { Component, routes, status, loguserout, authData, ...rest } = props;
  const localAuthData = localStorageContent.getLocalUserData();

  const myLogout = () => {
    loguserout();
  };

  useEffect(() => {
    if (!localAuthData?.authenticated) {
      history.push("/");
    }
  }, [localAuthData, history]);

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (localAuthData && localAuthData.authenticated) {
          return <Component {...routeProps} routes={routes} />;
        } else {
          return <Redirect to="/" />;
        }
      }}
    />
  );
};

const mapStateToProps = (state: any) => {
  return {
    authData: state.authState,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loguserout: () => dispatch(authActionCreators.initAuthLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoutes);
